import { mutatorAction } from 'satcheljs';
import { mobileDeviceFullStore } from '../store/store';
export var markIsNotSendReadReceiptDirty = mutatorAction('markIsNotSendReadReceiptDirty', function (isDirty) {
    var store = mobileDeviceFullStore();
    store.isNotSendReadReceiptDirty = isDirty;
});
//# sourceMappingURL=markIsNotSendReadReceiptDirty.js.map